import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const careersImageCarouselBlockFields = `
  _id,
  _type,
  images[]{
    ${imageFields}
  }
`

export const CAREERS_IMAGE_CAROUSEL_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-image-carousel-block"][0]{
    ${careersImageCarouselBlockFields}
  }
`)
